import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    tipoGrupo: { label: i18n.t('app.type'), value: '' },
    verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
    verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
    verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
    send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
    { field: 'IdGrupo', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'Nombre', width: '250px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'idTipo', width: '200px', title: i18n.t('app.type'), format: 'TIPOS_GRUPO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'Usuarios', width: '440px', title: i18n.t('users.header'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', sortable: false, groupable: false },
    { field: 'EnUso', width: '225px', title: i18n.t('app.in_use'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoGrupos', width: '225px', title: i18n.t('configurations.ver_todo_groups'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEstados', width: '225px', title: i18n.t('configurations.ver_todo_statuses'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEmpresas', width: '225px', title: i18n.t('configurations.ver_todo_companies'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EnviarAvisos', width: '150px', title: i18n.t('app.send_alerts'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EnviarAvisosUsuarios', width: '150px', title: i18n.t('configurations.send_alerts_users'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EmailAvisoNuevaEmitida', title: i18n.t('companies.email_nueva_emitida'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoNuevaRecibida', title: i18n.t('companies.email_nueva_recibida'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoCambioEstado', title: i18n.t('companies.email_cambio_estado'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoVinculaciones', title: i18n.t('companies.email_aviso_vincul'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
